




























import { Vue, Component, Prop } from 'vue-property-decorator'
import icon from 'components/presenter/item/ItemIcon'
import PersonAvatar from 'components/account/PersonAvatar.vue'
import { Item } from 'src/graphql/types'

@Component({
  components: {
    PersonAvatar
  }
})
export default class ItemFolderContentSubfolders extends Vue {
  icon = icon

  @Prop()
  readonly folders!: Item[]
}
